import { AxiosResponse } from "axios";
import { Result } from "@/main/models/common/resultResponse";

import { PurchaseCriteriaRequest } from "@/main/models/request/purchaseCriteriaRequest";
import { PurchaseCriteriaResponse } from "@/main/models/response/purchaseCriteriaResponse";

export abstract class IPurchaseCriteriaApi {
	abstract savePurchaseCriteria(
		request: PurchaseCriteriaRequest,
	): Promise<AxiosResponse<Result<PurchaseCriteriaResponse>>>;

	abstract deletePurchaseCriteria(request: string[]): Promise<AxiosResponse<Result<PurchaseCriteriaResponse[]>, any>>;
}
